import { cn } from "../../utils/cn";
import { FileSpreadsheet, FileText, Loader2 } from "lucide-react";

interface DownloadButtonProps {
  startDate?: string;
  endDate?: string;
  mutation: any;
  customerId?: string;
}

const DownloadButton = ({
  startDate,
  endDate,
  mutation,
  customerId,
}: DownloadButtonProps) => {
  const handleDownload = (docType: "PDF" | "EXCEL") => {
    if (mutation.isPending) return;
    mutation.mutate({
      startDate: startDate,
      endDate: endDate,
      docType: docType,
      download: true,
      customerId: customerId,
    });
  };

  const isDisabled = (startDate && endDate) || !!customerId;

  return (
    <div className="flex gap-3">
      <button
        type="button"
        disabled={mutation.isPending || !isDisabled}
        className={cn(
          "h-11 rounded-[12px] bg-[#1A5EF9] px-5 text-white font-medium text-sm flex items-center gap-2 hover:bg-[#0E4FDE] transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
        )}
        onClick={() => handleDownload("EXCEL")}
      >
        {mutation.isPending ? (
          <Loader2 className="animate-spin w-4 h-4" />
        ) : (
          <FileSpreadsheet className="w-4 h-4" />
        )}
        Export to Excel
      </button>
      <button
        type="button"
        disabled={mutation.isPending || !isDisabled}
        className={cn(
          "h-11 rounded-[12px] bg-[#1A5EF9] px-5 text-white font-medium text-sm flex items-center gap-2 hover:bg-[#0E4FDE] transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
        )}
        onClick={() => handleDownload("PDF")}
      >
        {mutation.isPending ? (
          <Loader2 className="animate-spin w-4 h-4" />
        ) : (
          <FileText className="w-4 h-4" />
        )}
        Export to PDF
      </button>
    </div>
  );
};

export default DownloadButton;
